import { render, staticRenderFns } from "./CarddestiPhone.vue?vue&type=template&id=3c34badb&scoped=true&"
import script from "./CarddestiPhone.vue?vue&type=script&lang=js&"
export * from "./CarddestiPhone.vue?vue&type=script&lang=js&"
import style0 from "./CarddestiPhone.vue?vue&type=style&index=0&id=3c34badb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c34badb",
  null
  
)

export default component.exports